import { render, staticRenderFns } from "./ComboActivatorButton.vue?vue&type=template&id=2f795215&scoped=true&lang=pug"
import script from "./ComboActivatorButton.vue?vue&type=script&lang=ts"
export * from "./ComboActivatorButton.vue?vue&type=script&lang=ts"
import style0 from "./ComboActivatorButton.vue?vue&type=style&index=0&id=2f795215&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f795215",
  null
  
)

export default component.exports